import * as types from '../types';

function trialRegistration(state = {
  isFetching: false,
  isFetchingValidation: false,
  hasValidated: false,
  trialToken: {},
  errors: [],
  isRegistered: false,
}, action) {
  switch (action.type) {
  case types.VALIDATE_TRIAL_TOKEN_REQUEST:
    return { ...state,
        isFetchingValidation: true,
        trialToken: {},
        errors: [],
      };

  case types.VALIDATE_TRIAL_TOKEN_SUCCESS:
    return { ...state,
        isFetchingValidation: false,
        hasValidated: true,
        trialToken: action.response,
        errors: [],
      };

  case types.VALIDATE_TRIAL_TOKEN_FAILURE:
    return { ...state,
        isFetchingValidation: false,
        hasValidated: false,
        trialToken: {},
        errors: action.errors,
      };
  case types.TRIAL_REGISTRATION_REQUEST:
    return { ...state,
        isFetching: true,
        isRegistered: false,
      };

  case types.TRIAL_REGISTRATION_SUCCESS:
    return { ...state,
        isFetching: false,
        isRegistered: true,
      };

  case types.TRIAL_REGISTRATION_FAILURE:
    return { ...state,
        isFetching: false,
        isRegistered: false,
      };

  default:
    return state;
  }
}

export default trialRegistration;



// WEBPACK FOOTER //
// ./src/reducers/trialregistration.js